import { useAuth } from "../lib/auth";
import { useMessages } from "./messages/useMessages";
import { MessagesView } from "./messages/MessagesView";
export default function Messages() {
  const { user } = useAuth();
  return <MessagesContent key={`${user?.id}:${user?.activeContext}`} />;
}
function MessagesContent() {
  return <MessagesView {...useMessages()} />;
}
